/**
 * Created by Victor Rojo on 16/1/18.
 */
import { Component }        from '@angular/core';
import { FormGroup, FormControl,
  FormBuilder, Validators }  from '@angular/forms';
import { ActivatedRoute }           from '@angular/router';
import { NotificationsService }     from 'angular2-notifications';

import { AuthService }  from '../auth.service';
import { Credential }   from "../credential";
import { I18NService }  from "../../i18n/i18n.service";

@Component({
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.css'],
})
export class PasswordRecoveryComponent {

  passwordRecoverForm: FormGroup;
  isBusy = false;
  public toastOptions = {
    position: ["top", "right"],
    timeOut: 3000,
    theClass: "bg-teal",
    lastOnBottom: true,
    showProgressBar: true,
    pauseOnHover: false,
  };
  recoverySent = false;
  private token:string;
  private login:string;
  customization = '';
  tenant = '';

  constructor(private fb: FormBuilder,
              private authService: AuthService,
              private activatedRoute: ActivatedRoute,
              private i18nService: I18NService,
              private notificationService: NotificationsService) {
    this.passwordRecoverForm = fb.group({
      'email' : [null, Validators.compose([Validators.required, Validators.email])],
    })

    if ( document.location.hostname  == "galp.cloud.ipetrol.es") {
      this.customization = "galp ipetrol";
      this.tenant = "galp";
    } else if ( document.location.hostname  == "ask.cloud.ipetrol.es" ) {
      this.customization = "ask ipetrol";
      this.tenant = "ask";
    } else if ( document.location.hostname  == "ecuador.cloud.ipetrol.es" ) {
      this.customization = "ecuador ipetrol";
      this.tenant = "ecuador";
    } else if ( document.location.hostname  == "q8.cloud.ipetrol.es" ) {
      this.customization = "q8 ipetrol";
      this.tenant = "q8";
    } else if ( document.location.hostname  == "ecomanager.cloud.ipetrol.es" ) {
      this.customization = "ecomanager ipetrol";
      this.tenant = "ecomanager";
    } else if ( document.location.hostname  == "cloud.ipetrol.es") {
      this.customization = "ipetrol";
      this.tenant = "";
    } else if ( document.location.hostname  == "hiotera.cloud.iplace.es" ) {
      this.customization = "hiotera";
      this.tenant = "hiotera";
    }  else if ( document.location.hostname  == "nacexa.cloud.iplace.es" ) {
      this.customization = "nacexa";
      this.tenant = "nacexa";
    } else if ( document.location.hostname  == "geo4radon.cloud.iplace.es" ) {
      this.customization = "geo4radon";
      this.tenant = "geo4radon";
    } else if ( document.location.hostname  == "freeenergia.cloud.iplace.es" ) {
      this.customization = "freeenergia";
      this.tenant = "freeenergia";
    } else if ( document.location.hostname  == "kontrolwat.cloud.iplace.es" ) {
      this.customization = "kontrolwat";
      this.tenant = "kontrolwat";
    } else if ( document.location.hostname  == "respira.cloud.iplace.es" ) {
      this.customization = "respira";
      this.tenant = "respira";
    } else if ( document.location.hostname  == "iotino.cloud.iplace.es" ) {
      this.customization = "iotino";
      this.tenant = "iotino";
    } else if ( document.location.hostname  == "depourense.cloud.iplace.es" ) {
      this.customization = "depourense";
      this.tenant = "depourense";
    } else if ( document.location.hostname == "h2h.cloud.iplace.es" ) {
      this.customization = "h2h";
      this.tenant = "h2h";
    } else if ( document.location.hostname == "hacsuite.cloud.iplace.es" ) {
      this.customization = "hacsuite";
      this.tenant = "hacsuite";
    } else if ( document.location.hostname == "smartpadel.cloud.iplace.es" ) {
      this.customization = "smartpadel";
      this.tenant = "smartpadel";
    }
  }

  recover():void{
    let data = {
      email: this.passwordRecoverForm.controls["email"].value
    };
    if ( this.passwordRecoverForm.valid ) {
      this.isBusy = true;
      this.authService.passwordRecovery(data)
        .then(res => {
          if ( res == 'true' ) {
            this.recoverySent = true;
          } else {
            this.notificationService.error(
              this.i18nService.get("error"),
              this.i18nService.get("notAccountForEmail")
            );
          }
          this.isBusy = false;
        })
        .catch( error => {
          this.isBusy = false;
          this.notificationService.error(
            this.i18nService.get("error"),
            this.i18nService.get("cantSendPasswordRecovery")
          );
        });
    }
  }
}
